import React, { useRef, useState } from 'react';
import { Overlay, OverlayTrigger, Table, Well } from "react-bootstrap"

export interface IAuditReportScoreOverlay {
    reportName: string,
    scoreValue: string,
    overlay: any
}

export default function AuditReportScoreTable({ reportName, scoreValue, overlay }: IAuditReportScoreOverlay) {
    const [show, setShow] = useState(false);
    const containerRef = useRef(null);
    
    return (
        <div ref={containerRef} style={{ display: 'flex', border: '1px solid #ddd', backgroundColor: '#fff', padding: 5, borderRadius: 4 }}>
            <div style={{ marginRight: 10 }}>{reportName}:</div>
            <div>
                <Overlay target={containerRef.current} show={show} placement='left'>
                    {overlay}
                </Overlay>

                <div style={{ cursor: 'pointer' }} onMouseOver={() => setShow(true)} onMouseOut={() => setShow(false)}>
                    <strong>{scoreValue}</strong>
                </div>
            </div>
        </div>
    );
};